import ManagePermission from "./ManagePermission";
export default ManagePermission;